import LoginApi from "../api/LoginApi";
import { TOKEN_ACCESS, TOKEN_SESSION, USER_EMAIL, USER_NAME } from "../constants";
import useGlobalStore from "../stores/GlobalStore";

/**
 * 打開對話框
 * @param setState - 用於更新對話框狀態的 setState 方法
 */
export const openDialog = (setState: React.Dispatch<React.SetStateAction<boolean>>) => {
    setState(true);
};

/**
 * 關閉對話框
 * @param setState - 用於更新對話框狀態的 setState 方法
 */
export const closeDialog = (setState: React.Dispatch<React.SetStateAction<boolean>>) => {
    setState(false);
};

export const isLogin = () => {
    let login = false;

    if (getLocalStorage(TOKEN_SESSION) && getLocalStorage(TOKEN_ACCESS)) {
        login = true;
    }

    return login;
}

export const logout = () => {
    LoginApi.logout();
    removeLocalStorage(TOKEN_SESSION);
    removeLocalStorage(TOKEN_ACCESS);
    removeLocalStorage(USER_NAME);
    removeLocalStorage(USER_EMAIL);
}

export const useLoading = () => {
    const { loading, setLoading } = useGlobalStore();

    const startLoading = () => setLoading(true);
    const stopLoading = () => setLoading(false);
    const getLoadingStatus = () => loading;

    return { startLoading, stopLoading, getLoadingStatus };
};

export const getRandomId = () => {
    return Date.now().toString(36) + Math.random().toString(36).substring(2);
}

export const getLocalStorage = (key: string) => {
    return localStorage.getItem(key) || '';
}

export const addLocalStorage = (key: string, value: any) => {
    localStorage.setItem(key, value);
}

export const removeLocalStorage = (key: string) => {
    localStorage.removeItem(key);
}

export const useError = () => {
    const { setErrMsg, setShowErrMsg } = useGlobalStore();

    const setError = (msg: string) => {
        setErrMsg(msg);
        setShowErrMsg(true);
    }

    return { setError };
}

export const isJSON = (value: any): boolean => {
    try {
        const parsed = typeof value === "string" ? JSON.parse(value) : value;

        return parsed !== null &&
            typeof parsed === "object" &&
            !Array.isArray(parsed) &&
            isValidJson(parsed);
    } catch (e) {
        console.error("JSON parse error:", e);
        return false;
    }
};

const isPrimitive = (value: any): boolean => {
    return (
        value === null ||
        typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean"
    );
};

const isValidJson = (json: Record<string, any>): boolean => {
    return Object.values(json).every(isPrimitive);
};


export const isArray = (value: any): boolean => {
    try {
        const parsed = typeof value === "string" ? JSON.parse(value) : value;

        if (!Array.isArray(parsed) || parsed.length === 0) return false;

        return parsed.every(item => isObjectWithPrimitiveValues(item));

    } catch (e) {
        console.error("JSON parse error:", e);
        return false;
    }
};

const isObjectWithPrimitiveValues = (obj: any): boolean => {
    return typeof obj === "object" && obj !== null &&
        !Array.isArray(obj) &&
        Object.values(obj).every(isPrimitive);
};

